import React, { useCallback, useMemo } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import { Radio, Tooltip } from '@mui/material';
import ImageTooltip from './ImageTooltip';

const getStyles = chosenImageId => ({
  container: {
    p: 1,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    boxShadow: chosenImageId ? '1px 1px 50px -10px grey' : 'none',
    border: chosenImageId ? `2px solid transparent` : '2px solid #E0E0E0',
    background: chosenImageId
      ? 'linear-gradient(#fff, #fff) padding-box, linear-gradient(to left, #82E600, #49B487, #0080A7) border-box'
      : 'white',
    transition: 'box-shadow 0.3s ease-in-out',
    '&: hover': {
      cursor: 'pointer',
      border: `2px solid transparent`,
      background:
        'linear-gradient(#fff, #fff) padding-box, linear-gradient(to left, #82E600, #49B487, #0080A7) border-box',
    },
  },
  info: {
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '37px',
    bgcolor: 'secondary.main',
    borderRadius: '4px',
    color: 'white',
    fontSize: '14px',
    p: 1,
    mt: 'auto',
  },
  icon: {
    color: 'white',
    border: '2px solid transparent',
    transition: 'border-color 0.3s ease-in-out',
    '&: hover': { border: 2 },
  },
});

const ImageDetails = props => {
  const { image, selectedImage, setSelectedImage } = props;
  const { id, title, fileSizeString, link, infoLink, mediaType, updateDate } = image;

  const chosenImageId = selectedImage?.id === id;

  const styles = useMemo(() => getStyles(chosenImageId), [chosenImageId]);

  const handleChange = useCallback(() => {
    setSelectedImage(image);
  }, [image, setSelectedImage]);

  return (
    <Tooltip
      title={<ImageTooltip mediaType={mediaType} updateDate={updateDate} />}
      placement="bottom-end"
      slotProps={{
        popper: {
          sx: {
            zIndex: 20000,
          },
        },
      }}
    >
      <Box sx={styles.container} onClick={handleChange}>
        <Radio
          sx={{ justifyContent: 'flex-start' }}
          checked={chosenImageId}
          onChange={handleChange}
          value={id}
          name="radio-buttons"
        />
        <Box display="flex" justifyContent="center" mb={2}>
          <img src={link} alt="product-image" style={{ maxWidth: '70%' }} />
        </Box>
        <Stack direction="row" sx={styles.info}>
          <Box whiteSpace="nowrap">{fileSizeString}</Box>
          <Box sx={{ wordBreak: 'break-word' }} textAlign="center" mx={1}>
            {title}
          </Box>
          {infoLink && (
            <a href={infoLink} target="_blank" rel="noopener noreferrer" aria-label="Info Link">
              <IconButton sx={styles.icon}>
                <InfoIcon />
              </IconButton>
            </a>
          )}
        </Stack>
      </Box>
    </Tooltip>
  );
};

export default ImageDetails;
